import React, { useState } from "react";
import numerology from "../assets/rootimg/numeroimg.jpg";
import Queryform from "./Queryform";
import Footer from "../home/Footer";
import rings from "../assets/rootimg/two-rings.png";
import dailyHoroscope from "../assets/rootimg/kundlicomp.png";
import dailytarotImage from "../assets/zodiacSign/dailytarot.png";
import { useLocation, useNavigate } from 'react-router';
import Navbar from "../home/Navbar";
import BlogRecommendations from "./AstroBlog/BlogRecommendations";
import { API_END_POINT } from "./Utils/Constant";

const Numero = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    dateOfBirth: ''
  });
  const [numerologyData, setNumerologyData] = useState(null);
  const [dayNumberData, setDayNumberData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('destiny');

  // Function to get color based on number
  const getNumberColor = (number) => {
    const colors = {
      1: 'text-red-600',
      2: 'text-blue-600',
      3: 'text-green-600',
      4: 'text-yellow-600',
      5: 'text-purple-600',
      6: 'text-pink-600',
      7: 'text-indigo-600',
      8: 'text-orange-600',
      9: 'text-teal-600',
      11: 'text-red-800',
      22: 'text-blue-800',
      33: 'text-green-800'
    };
    return colors[number] || 'text-secondary';
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      // Format the date for the query parameters
      const formattedDate = new Date(formData.dateOfBirth).toISOString().split('T')[0];
      
      // Fetch numerology details using GET with query parameters
      const numerologyUrl = `${API_END_POINT}numero/numerology?name=${encodeURIComponent(formData.name)}&dateOfBirth=${encodeURIComponent(formattedDate)}`;
      const numerologyResponse = await fetch(numerologyUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!numerologyResponse.ok) {
        throw new Error('Failed to fetch numerology data');
      }
      
      const numerologyResult = await numerologyResponse.json();
      setNumerologyData(numerologyResult.data);
      
      // Fetch day number details using GET with query parameters
      const dayNumberUrl = `${API_END_POINT}numero/day-number?dateOfBirth=${encodeURIComponent(formattedDate)}`;
      const dayNumberResponse = await fetch(dayNumberUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!dayNumberResponse.ok) {
        throw new Error('Failed to fetch day number data');
      }
      
      const dayNumberResult = await dayNumberResponse.json();
      setDayNumberData(dayNumberResult.data);
      
    } catch (err) {
      setError(err.message);
      console.error('Error fetching numerology data:', err);
    } finally {
      setLoading(false);
    }
  };


  const kundliClick = () => {
    navigate('/kundlimatching');
  }
  const tarotClick = () => {
    navigate('/tarot');
  }
  const horoscopeClick = () => {
    navigate('/horoscope');
  }

  // Function to render numerology card
  const renderNumerologyCard = (data, title, category) => {
    if (!data || !data.response || !data.response[category]) return null;
    
    const item = data.response[category];
    const numberColorClass = getNumberColor(item.number);
    
    return (
      <div className={`bg-white p-6 rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105 my-4 ${activeTab === category ? 'border-2 border-secondary' : ''}`}>
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold text-white bg-gradient-to-r from-success to-[#9034E9] p-1 px-2 w-fit rounded-md">{item.title}</h3>
          <div className="flex items-center">
            <span className={`text-3xl font-bold ${numberColorClass} mr-2`}>{item.number}</span>
            {item.master && (
              <span className="bg-purple-100 text-purple-800 text-xs font-semibold px-2.5 py-0.5 rounded-full">
                Master
              </span>
            )}
          </div>
        </div>
        <p className="text-gray-700 mb-3">{item.meaning}</p>
        <p className="text-sm text-gray-500 italic">{item.description}</p>
      </div>
    );
  };

  return (
    <>
      <section className="bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen">
        <div>
          <Navbar />
        </div>

        {/* Numerology Form Section */}
        <div className="text-gray-900 flex flex-col items-center mt-12">
          <h1 className="text-4xl text-secondary font-serif font-bold mb-2">NUMEROLOGY</h1>
          <p className="text-lg mb-8 font-serif text-secondary text-center max-w-2xl">
            Discover your numerology details by entering your name and date of birth below.
          </p>
          
          {/* Form and Image in Flex Row */}
          <div className="md:w-2/3 lg:w-3/5 sm:w-full mx-auto mb-12">
            <div className="">
              <div className="bg-slate-100 p-8 rounded-lg shadow-lg">
                <form onSubmit={handleSubmit} className="space-y-6">
                  <h2 className="text-lg font-bold text-white bg-gradient-to-r from-secondary to-purple-600 p-2 rounded-md text-center">Numerology Details</h2>
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                      Full Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-secondary"
                      placeholder="Enter your full name"
                      required
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="dateOfBirth" className="block text-sm font-medium text-gray-700 mb-1">
                      Date of Birth
                    </label>
                    <input
                      type="date"
                      id="dateOfBirth"
                      name="dateOfBirth"
                      value={formData.dateOfBirth}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-secondary"
                      required
                    />
                  </div>
                  
                  <div className="text-center">
                    <button
                      type="submit"
                      className="bg-gray-900 text-white py-2 px-6 w-full rounded-md hover:bg-secondary transition-colors duration-300 font-medium"
                      disabled={loading}
                    >
                      {loading ? 'Loading...' : 'Get Your Numerology Details'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          
          {/* Display Results */}
          {error && (
            <div className="mt-6 p-4 bg-red-100 text-red-700 rounded-md w-full max-w-md">
              <p className="font-medium">Error: {error}</p>
              <p>Please try again later.</p>
            </div>
          )}
          
          {numerologyData && (
            <div className="mt-8 w-full max-w-6xl">
              <h2 className="text-2xl font-bold text-white bg-gradient-to-r from-success to-[#9034E9] p-2 rounded-md mb-6 text-center">Your Numerology Profile</h2>
              
              {/* Tabs for different numerology aspects */}
              <div className="flex flex-wrap justify-center mb-6 gap-2">
                <button 
                  onClick={() => setActiveTab('destiny')}
                  className={`px-4 py-2 rounded-md transition-colors ${activeTab === 'destiny' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                >
                  Destiny
                </button>
                <button 
                  onClick={() => setActiveTab('personality')}
                  className={`px-4 py-2 rounded-md transition-colors ${activeTab === 'personality' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                >
                  Personality
                </button>
                <button 
                  onClick={() => setActiveTab('attitude')}
                  className={`px-4 py-2 rounded-md transition-colors ${activeTab === 'attitude' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                >
                  Attitude
                </button>
                <button 
                  onClick={() => setActiveTab('character')}
                  className={`px-4 py-2 rounded-md transition-colors ${activeTab === 'character' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                >
                  Character
                </button>
                <button 
                  onClick={() => setActiveTab('soul')}
                  className={`px-4 py-2 rounded-md transition-colors ${activeTab === 'soul' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                >
                  Soul Urge
                </button>
                <button 
                  onClick={() => setActiveTab('agenda')}
                  className={`px-4 py-2 rounded-md transition-colors ${activeTab === 'agenda' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                >
                  Hidden Agenda
                </button>
                <button 
                  onClick={() => setActiveTab('purpose')}
                  className={`px-4 py-2 rounded-md transition-colors ${activeTab === 'purpose' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                >
                  Divine Purpose
                </button>
              </div>
              
              {/* Display the active tab content */}
              <div className="mb-8">
                {renderNumerologyCard(numerologyData, 'Destiny', 'destiny')}
                {renderNumerologyCard(numerologyData, 'Personality', 'personality')}
                {renderNumerologyCard(numerologyData, 'Attitude', 'attitude')}
                {renderNumerologyCard(numerologyData, 'Character', 'character')}
                {renderNumerologyCard(numerologyData, 'Soul Urge', 'soul')}
                {renderNumerologyCard(numerologyData, 'Hidden Agenda', 'agenda')}
                {renderNumerologyCard(numerologyData, 'Divine Purpose', 'purpose')}
              </div>
            </div>
          )}
          
          {/* Day Number Section */}
          {dayNumberData && (
            <div className="mt-8 bg-gray-100 p-6 rounded-lg shadow-lg w-full max-w-5xl">
              <h2 className="text-2xl font-bold text-white bg-gradient-to-r from-success to-[#9034E9] p-2 rounded-md mb-4 text-center">Your Day Number</h2>
              
              <div className="bg-slate-200 p-6 rounded-md">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-xl font-semibold text-secondary">{dayNumberData.response.title}</h3>
                  <div className="flex items-center">
                    <span className={`text-3xl font-bold ${getNumberColor(dayNumberData.response.number)} mr-2`}>
                      {dayNumberData.response.number}
                    </span>
                    {dayNumberData.response.master && (
                      <span className="bg-purple-100 text-purple-800 text-xs font-semibold px-2.5 py-0.5 rounded-full">
                        Master
                      </span>
                    )}
                  </div>
                </div>
                <p className="text-gray-700 mb-3">{dayNumberData.response.meaning}</p>
                <p className="text-sm text-gray-500 italic">{dayNumberData.response.description}</p>
              </div>
            </div>
          )}
        </div>
        
        <div className="flex flex-col items-center mt-10 text-center px-4 sm:px-6 md:px-8 lg:px-10 max-w-6xl mx-auto">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900">
              About Numerology
            </h3>
            <p className="text-sm sm:text-base text-justify mt-4 leading-relaxed">
              Numerology compatibility delves into the profound influence of numbers on relationships, examining how each individual's
              Life Path Number, Expression Number, and Soul Urge Number shape their interactions. By analyzing the vibrations of these
              core numbers, numerology uncovers strengths, challenges, and the natural flow of energy between people.
            </p>
           
            <p className="text-sm sm:text-base text-justify mt-2 leading-relaxed">
              <strong>Numerology</strong> examines the alignment of key numbers in family dynamics, offering insights into how different
              energies coexist and support one another.
            </p>
        </div>

        <div className="mt-6 flex flex-col ml-4 sm:ml-8 md:ml-16 lg:ml-16 mr-4 sm:mr-8 md:mr-16 lg:mr-16 justify-center items-center">
          <h1 className="text-center text-lg sm:text-xl md:text-2xl text-secondary  font-bold">
            Recommended Reports For You
          </h1>
          {/* Parent Card div */}
          <div className="flex flex-wrap gap-5 justify-center mt-5">
            {/* Card 1 */}
            <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
              <div className="flex flex-col items-center">
                <img
                  src={rings}
                  alt="kundli.png"
                  className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                />
                <div className="text-center">
                  <h3 className="text-lg sm:text-xl font-bold mb-2 text-center text-secondary">Kundli Matching</h3>
                  <p className="text-justify text-xs sm:text-sm md:text-base m-3 mb-4">
                    Kundli Matching helps you find a match for your astrological traits and preferences. By comparing your birth
                    chart with others in the database, you can find a person who shares your similarities, characteristics, and
                    compatible energies.
                  </p>
                  <button
                    onClick={kundliClick}
                    className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                  >
                    Match Kundli
                  </button>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
              <div className="flex flex-col items-center">
                <img
                  src={dailytarotImage}
                  alt="daily-horoscope.png"
                  className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                />
                <div className="text-center">
                  <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Tarot Rading</h3>
                  <p className="text-xs text-justify sm:text-sm md:text-base m-3 mb-6">
                    Tarot reading provides guidance by revealing hidden energies, emotions, and possibilities. By drawing cards
                    and interpreting meanings, you gain clarity on challenges, relationships, and opportunities. Each reading empowers
                    you to make informed decisions.

                  </p>
                  <button
                    onClick={tarotClick}
                    className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                  >
                    Start Reading
                  </button>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
              <div className="flex flex-col items-center">
                <img
                  src={dailyHoroscope}
                  alt="daily-horoscope.png"
                  className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                />
                <div className="text-center">
                  <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Daily Horoscope</h3>
                  <p className="text-xs text-justify sm:text-sm md:text-base m-3 mb-6">
                    Get your personalized daily horoscope and insights for the day ahead. Stay prepared and make the
                    most of your day with astrological guidance to navigate challenges, seize opportunities, and align with cosmic energy.
                  </p>
                  <button
                    onClick={horoscopeClick}
                    className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                  >
                    View Horoscope
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
        <BlogRecommendations/>
        <div>
          <Queryform />
        </div>
        <div>
          <Footer />
        </div>
      </section>
    </>
  );
};

export default Numero;
